import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
@Component({
  selector: 'app-show-renderer',
  templateUrl: './show-renderer.component.html',
  styleUrls: ['./show-renderer.component.scss']
})
export class ShowRendererComponent implements ICellRendererAngularComp  {

  constructor() { }

  ngOnInit(): void {
  }
  params: any;
  getLabelFunction: any;

  agInit(params: any): void {
      this.params = params;
      this.getLabelFunction = this.params.getLabelFunction;
  }

  refresh(params?: any): boolean {
      return true;
  }
  isPopup(): boolean {
      return false;
  }
  onClick($event) {
      if (this.params.onClick instanceof Function) {
          const params = {
              event: $event,
              rowData: this.params.node,
          };
          this.params.onClick(params);
      }
  }

}
